export default "__VITE_ASSET__CdxrWTJG__"